import imgUnified from '../../assets/wizard-integration/experience-unified.svg';
import imgClassic from '../../assets/wizard-integration/experience-classic.svg';
import imgWidget from '../../assets/wizard-integration/experience-widget.svg';

// Shared presentation only. Stored mode IDs and configuration behavior are owned by each flow.
export const SEARCH_EXPERIENCES = [
  {
    type: 'classic',
    nameKey: 'wizard.searchSetup.experience.classic.title',
    descriptionKey: 'wizard.searchSetup.experience.classic.description',
    features: [
      'wizard.searchSetup.experience.classic.feature.suggestions',
      'wizard.searchSetup.experience.classic.feature.page',
      'wizard.searchSetup.experience.classic.feature.filters',
    ],
    image: imgClassic,
    recommended: false,
  },
  {
    type: 'unified',
    nameKey: 'wizard.searchSetup.experience.unified.title',
    descriptionKey: 'wizard.searchSetup.experience.unified.description',
    features: [
      'wizard.searchSetup.experience.unified.feature.products',
      'wizard.searchSetup.experience.unified.feature.filters',
      'wizard.searchSetup.experience.unified.feature.page',
    ],
    image: imgUnified,
    recommended: true,
  },
  {
    type: 'fullpage',
    nameKey: 'wizard.searchSetup.experience.fullpage.title',
    descriptionKey: 'wizard.searchSetup.experience.fullpage.description',
    features: [
      'wizard.searchSetup.experience.fullpage.feature.focus',
      'wizard.searchSetup.experience.fullpage.feature.filters',
    ],
    image: imgWidget,
    recommended: false,
  },
];
